// extracted by mini-css-extract-plugin
export default {"print-page-break":"styles_print-page-break__nxD4p"};